<template>
  <div class="flex min-h-screen flex-col" :id="$page.props.page ? `page${$page.props.page.id}` : null">
    <a class="skip-link" href="#main">Skip to content</a>
    <slot />
    <NtValuationCta v-if="$hasIntegration('valuation_cta')" />
    <NtCookieConsent />
  </div>
</template>

<script>
import NtCookieConsent from '../general/NtCookieConsent.vue'
import NtValuationCta from '../general/NtValuationCta.vue'

export default {
  components: { NtCookieConsent, NtValuationCta }
}
</script>
